import { PROFILE } from "../shared/Brand";

// About Section - Philosophy + Bio
export const AboutSection = () => (
  <section id="about" className="py-12 sm:py-16 lg:py-20 bg-[#0A0A0A] overflow-hidden">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
      {/* Statement */}
      <div className="text-center mb-10 sm:mb-14">
        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-semibold text-white tracking-tight leading-tight mb-4 sm:mb-6">
          AI scales effort. <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#E8C547]">It doesn't repair a broken system.</span>
        </h2>
        <p className="text-base sm:text-lg text-zinc-300 max-w-3xl mx-auto leading-relaxed px-2">
          The companies that win build strong execution, develop elite talent, and align their GTM motion before adding automation.
        </p>
      </div>

      {/* About Dan - Enhanced Bio Card */}
      <div className="p-6 sm:p-8 lg:p-10 bg-[#1C1C1C] rounded-2xl border border-white/5">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 sm:gap-8">
          {/* Content */}
          <div className="text-center md:text-left flex-1">
            {/* Name - Most prominent */}
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-1.5 tracking-tight">Dan Leitner</h3>
            
            {/* Title - Smaller, gold */}
            <p className="text-[#D4AF37] text-sm sm:text-base font-medium mb-5">Sales Development & GTM Leader</p>
            
            <div className="space-y-3 mb-6">
              <p className="text-base sm:text-lg text-zinc-200 leading-relaxed">
                I build SDR organizations from zero, rebuild underperforming teams, and scale pipeline efficiently for B2B SaaS companies.
              </p>
              <p className="text-base sm:text-lg text-zinc-200 leading-relaxed">
                My work often extends beyond the SDR org itself. I stay closely involved in the systems behind pipeline, including Salesforce and HubSpot, lead routing, lifecycle workflows, reporting, Sales and Marketing handoffs, AI-assisted prospecting, events, and other GTM operational projects.
              </p>
              <p className="text-base sm:text-lg text-zinc-200 leading-relaxed">
                I stay close to execution as well: prospecting, cold calling, messaging, coaching, account strategy, and live deal support.
              </p>
            </div>

            <div className="flex flex-wrap justify-center md:justify-start gap-2 mb-6" data-testid="about-capabilities">
              {["Sales Development Leadership", "GTM Operations", "Sales + Marketing Alignment", "RevOps Partnership", "CRM & Workflow Design", "Pipeline Reporting & Conversion", "AI-Assisted GTM Workflows"].map((c) => (
                <span key={c} className="px-3 py-1.5 bg-[#0A0A0A] border border-white/5 rounded-full text-xs sm:text-sm text-zinc-300">{c}</span>
              ))}
            </div>
            
            <div className="flex justify-center md:justify-start">
              <a 
                href={PROFILE.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 bg-[#D4AF37] text-[#0A0A0A] rounded-lg font-semibold text-sm sm:text-base hover:bg-[#E8C547] transition-colors shadow-lg shadow-[#D4AF37]/20"
                data-testid="bio-cta"
              >
                Connect on LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
